import { LoginStatusButton } from '@modules/auth/controllers/login-status-button'
import { Venue } from 'types/model'
import { VenueSocialLinks } from './venue-social-links'
import { useScrollPosition } from '@hooks/scroll-position'
import classNames from 'classnames'
import { imageOptimize } from '@utils/images'
import { Link } from '@elements/link'

export function VenuePageHeader({
  venue,
  showLogo = false,
  transparent = false,
}: {
  venue: Venue
  showLogo?: boolean
  transparent?: boolean
}) {
  const scrollPosition = useScrollPosition('#venue-page-main')
  const logoSrc = imageOptimize(venue.logo, { q: '80' })

  return (
    <header
      className={classNames(
        'fixed z-10 top-0 left-0 right-0 flex items-center justify-between w-screen px-3 sm:px-6 py-2 background-basic',
        'shadow-sm transition-all duration-100 ease-out',
        {
          '!text-white !bg-transparent': transparent,
          'shadow-transparent': transparent || scrollPosition.atTop,
          'shadow-black/[0.1] dark:shadow-stone-800':
            !transparent && !scrollPosition.atTop,
        }
      )}
    >
      <div className='flex items-center justify-start flex-1'>
        <VenueSocialLinks venue={venue} />
      </div>
      <div
        className={classNames(
          'flex flex-1 items-center justify-center transition-opacity',
          {
            'opacity-0': !showLogo,
            'opacity-100': showLogo,
          }
        )}
      >
        {logoSrc && (
          <Link
            href={`/v/${venue.slug}`}
            className={classNames({
              'cursor-default pointer-events-none': !showLogo,
            })}
          >
            {/* eslint-disable-next-line @next/next/no-img-element */}
            <img
              alt={venue.name}
              src={logoSrc}
              className='w-auto h-auto max-w-full max-h-[32px]'
            />
          </Link>
        )}
      </div>
      <div className='flex items-center justify-end flex-1'>
        <nav>
          <LoginStatusButton />
        </nav>
      </div>
    </header>
  )
}
